import * as React from 'react';
import { BlockProps } from 'components/Blocks/index.types';
import { setBlocksPropsFromAttributes } from 'components/Blocks/utils';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import PageSection from 'components/success-stories/page-section/page-section';
import MediaBox, { MediaBoxAspect } from 'components/media-box/media-box';
import CtaBox, { CtaBoxAlign } from 'components/cta-box/cta-box';
import CtaBoxMedia from 'components/cta-box/cta-box-media';
import FlexImageList from 'components/success-stories/flexible-image-list/flexible-image-list';
import Icon from 'components/icon/icon';

type BlockAttributesPropsType = {
    ctaText?: string;
    // @TODO update link names safely
    clatLink?: string;
    // @TODO add html based check
    ctaTarget?: string;
};

type BlockPropsType = {
    block: BlockProps;
} & {
    title?: string;
    subTitle?: string;
    text?: string;
    ctaText?: string;
    // @TODO update link names safely
    clatLink?: string;
    // @TODO add html based check
    ctaTarget?: string;
    mediaURLOne?: string;
    mediaURLTwo?: string;
    mediaURLThree?: string;
    mediaURLFour?: string;
    // @TODO add noreferrer - here and at BE ?
};

function CtaInstagramFeedSectionFullScreen({ block, ...props }: BlockPropsType) {
    const isBreakpoint = useMediaQuery(MediaQueryWidth['tablet-md']);
    const blockAttributes = setBlocksPropsFromAttributes(
        block.attributes
    ) as BlockAttributesPropsType;

    const CtaInstagramLinkWrapper: React.FC<React.PropsWithChildren> = ({ children }) =>
        blockAttributes.clatLink ? (
            <a
                className="flexible-image-list__item-action"
                href={blockAttributes.clatLink}
                target={blockAttributes.ctaTarget}
                aria-label={blockAttributes.ctaText}
            >
                {children}
            </a>
        ) : null;

    return (
        <PageSection isFullWidth={true} inner={false}>
            <CtaBox align={CtaBoxAlign.CENTERED}>
                <CtaBoxMedia fullWidth={true} marginTop={0}>
                    <FlexImageList grid={FlexImageList.Grid.FOUR} isFullWidth={true}>
                        {props.mediaURLOne ? (
                            <CtaInstagramLinkWrapper>
                                <MediaBox aspect={MediaBoxAspect.SQUARE} src={props.mediaURLOne} />
                            </CtaInstagramLinkWrapper>
                        ) : null}

                        {props.mediaURLTwo ? (
                            <CtaInstagramLinkWrapper>
                                <MediaBox aspect={MediaBoxAspect.SQUARE} src={props.mediaURLTwo} />
                            </CtaInstagramLinkWrapper>
                        ) : null}

                        {props.mediaURLThree ? (
                            <CtaInstagramLinkWrapper>
                                <MediaBox
                                    aspect={MediaBoxAspect.SQUARE}
                                    src={props.mediaURLThree}
                                />
                            </CtaInstagramLinkWrapper>
                        ) : null}

                        {!isBreakpoint && props.mediaURLFour ? (
                            <CtaInstagramLinkWrapper>
                                <MediaBox aspect={MediaBoxAspect.SQUARE} src={props.mediaURLFour} />
                            </CtaInstagramLinkWrapper>
                        ) : null}
                    </FlexImageList>
                </CtaBoxMedia>
            </CtaBox>

            {blockAttributes.clatLink ? (
                <div className="page-section__cta-icon-action">
                    <a
                        href={blockAttributes.clatLink}
                        target={blockAttributes.ctaTarget}
                        aria-label={props.ctaText}
                    >
                        <Icon size="stretch" name={Icon.Name.InstagramCta} />
                    </a>
                </div>
            ) : null}
        </PageSection>
    );
}

export { CtaInstagramFeedSectionFullScreen };
